module.exports = __webpack_public_path__ + "static/img/injuryPersonal.28aa10ee.png";